import {useMemo} from 'react'
import {useLocation} from 'react-router'

export type Breadcrumb = {
  name: string
  id: string
  label: string
}

export const useHierarchyBreadcrumb = (data: Breadcrumb[]) => {
  const location = useLocation()

  return useMemo(() => {
    const segments = location.pathname.split('/').filter(Boolean)
    const crumbs: {label: string; path: string}[] = []

    const firstHierarchyIndex = segments.findIndex((segment) =>
      data.some(({name}) => name === segment)
    )

    let builtPath = segments
      .slice(0, firstHierarchyIndex)
      .map((s) => `/${s}`)
      .join('')

    for (let i = firstHierarchyIndex; i < segments.length; i++) {
      const segment = segments[i]
      const breadcrumb = data.find(({name}) => name === segment)
      if (breadcrumb && i + 1 < segments.length) {
        const idSegment = segments[i + 1]
        builtPath += `/${segment}/${idSegment}`
        crumbs.push({
          label: breadcrumb.label || idSegment,
          path: builtPath
        })
        i++
      }
    }

    return crumbs
  }, [data, location.pathname])
}
